import React from 'react'
import router from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import { refererCookie } from 'libs/cookies'
import {
  ApplyExternalInput,
  ApplyExternalMutation,
  Job,
  useApplyExternalMutation,
} from 'generated/apolloComponents'
import { useSession } from 'next-auth/react'
import Button from '@/components/atoms/Button'

interface IProps {
  job: Job
  setApplicationSuccess?: React.Dispatch<React.SetStateAction<boolean>>
  applicationFromJobList?: boolean
  sidePanel?: boolean
}

const ApplicationButton = ({
  job,
  setApplicationSuccess = () => {},
  applicationFromJobList = false,
  sidePanel = false,
}: IProps) => {
  const { t } = useTranslation()
  const { data: session } = useSession()
  const [newWindow, setNewWindow] = React.useState<Window | null>(null)

  const [applyExternal] = useApplyExternalMutation({
    onCompleted: (data: ApplyExternalMutation) => {
      if (data.applyExternal?.applyUrl) {
        // @ts-ignore
        newWindow.location.href = data.applyExternal.applyUrl
        // @ts-ignore
        newWindow.focus()
      }
      setApplicationSuccess(true)
    },
  })

  const handleApplyClick = () => {
    if (job.internalApplication || !session) {
      router.push(`/companies/jobs/${job.id}/application`)
    } else {
      setNewWindow(window.open('', '_blank'))
      applyExternal({
        variables: {
          input: {
            jobId: job.id,
            referer: refererCookie(),
          },
        },
      })
    }
  }

  if (job.applied) {
    return (
      <Button
        data-cy='btn-apply'
        type='muted'
        size='medium'
        className={`${
          sidePanel ? 'w-full lg:w-[300px] xl:h-[40px] xl:py-2 xl:text-2xl' : ''
        } px-10`}
      >
        {t('common:applied_for_offer')}
      </Button>
    )
  }

  return (
    <Button
      onClick={handleApplyClick}
      data-cy='btn-apply'
      type='primary'
      size='medium'
      className={`${
        sidePanel ? 'w-full xl:w-[300px] xl:h-[40px] xl:py-2 xl:text-2xl' : ''
      } px-10`}
    >
      {t('common:apply')}
    </Button>
  )
}

export default ApplicationButton
